export const version = '0.796.0'
export const chameleonWebVersion = '9.19.0'
export const chameleonCoreVersion = '7.12.0'
